import moment from 'moment';
// Import localeUtils to ensure the language change listener is configured
import './localeUtils';

/**
 * Format time in HHmmss.SSS format (24h time) into HH:mm:ss
 *
 * @param time - Time to be formatted
 * @param format - Desired time format
 * @returns Formatted time
 */
export default function formatTime(time: string, format = 'HH:mm:ss') {
  // Moment locale is automatically updated by the language change listener
  return moment(time, 'HH:mm:ss').format(format);
}
